import { ComponentStyleConfig } from '@chakra-ui/react';

const BadgeStyles: ComponentStyleConfig = {
  baseStyle: {
    borderRadius: 'full',
  },
};

export default BadgeStyles;
